<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="table-header">
            <mat-card-title>Seguridad - Roles</mat-card-title>
            <button mat-flat-button color="primary"
            (click)="openRegisterDialogModal()">
                <mat-icon>add</mat-icon>
                Nuevo Rol
            </button>
        </div>
        <div class="contenedor">

            <app-role-list-table
                [roles]="roles$ | async">
            </app-role-list-table>

        </div>
    </mat-card-content>
</mat-card>
